/* Sagetile sliderelor de colectie LuxCanva. Fisier separat ca sa nu se repete in pagina
   o data pentru fiecare slider. Delegat, deci merge si daca sectiunile se incarca mai tarziu. */
(function () {
  function stare(t) {
    var w = t.closest('.lcs__wrap');
    if (!w) return;
    var p = w.querySelector('.lcs__nav--prev'), n = w.querySelector('.lcs__nav--next');
    if (p) p.disabled = t.scrollLeft < 6;
    if (n) n.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 6;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.lcs__nav') : null;
    if (!b) return;
    var t = b.closest('.lcs__wrap').querySelector('[data-lcs-track]');
    t.scrollBy({ left: b.getAttribute('data-lcs-dir') * t.clientWidth * 0.85, behavior: 'smooth' });
  });
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-lcs-track')) stare(e.target);
  }, true);
  function initToate() { document.querySelectorAll('[data-lcs-track]').forEach(stare); }
  if (document.readyState === 'complete') initToate();
  else addEventListener('load', initToate);
})();
